import FileSecurity from './FileSecurity.component';

export default FileSecurity;
